import { useEffect } from 'react';
import Modal from 'src/components/common/modal/Modal';
import { showBasketAtom } from 'src/state/ui/showBasket.atom';
import BasketPopup from 'src/widgets/activities/basket/BasketPopup';
import { useAtom } from 'ximple';
import { cartAtom } from 'src/state/cart/cartAtom';
import { useConfigurations } from '@repo/widget-utils/widgetsConfiguration';
import { octoOrderAtom, selectActiveBookings } from 'src/state/octo-cart/octoOrderAtom';
import { useSelector } from 'src/hooks';
import { octoCartAtom } from 'src/state/octo-cart/octoCartAtom';

export default function BasketWidget() {
    const configurations = useConfigurations();
    const [cart] = useAtom(cartAtom);
    const [octoCart] = useAtom(octoCartAtom);
    const [octoOrderState] = useAtom(octoOrderAtom);
    const activeOctoBookings = useSelector(octoOrderState, selectActiveBookings);

    useEffect(() => {
        if (configurations.octo) {
            if (!octoCart.id || (activeOctoBookings && activeOctoBookings.length === 0)) {
                showBasketAtom.update({ visible: false });
            }
        } else {
            if (cart.length === 0) {
                showBasketAtom.update({ visible: false });
            }
        }
    }, [cart, activeOctoBookings, configurations.octo, octoCart.id]);

    const [{ visible, refocusElementOnClose }] = useAtom(showBasketAtom);
    const onClose = () => showBasketAtom.update({ visible: false });

    return (
        <Modal open={visible} onClose={onClose} refocusElementOnClose={refocusElementOnClose}>
            <BasketPopup onCloseModal={onClose} />
        </Modal>
    );
}
